import { mapGetters, mapActions } from 'vuex';
import TranslationsMixin from '../../mixins/translations';
import ExchangeLineItem from '../../components/ExchangeLineItem/index.vue';
import TheExchangeSidebar from '../../components/TheExchangeSidebar/index.vue';
import DetailsAnalytics from './DetailsAnalytics';
import '@garmin/components-global-web/dist-web/components/GButton';

export default {
  name: 'ExchangeDetailsView',
  mixins: [TranslationsMixin],
  components: {
    ExchangeLineItem,
    TheExchangeSidebar,
  },
  data() {
    return {
      analyticsInstance: new DetailsAnalytics(),
      hasOrderCreatedError: false,
      isNextDisabled: false,
    };
  },
  computed: {
    ...mapGetters('customer', [
      'suppliedFormData',
      'deviceVerificationResponse',
      'exchangeIdentifier',
      'getSelectedCountryCode',
    ]),
    ...mapGetters('order', ['orderConfirmationResponse']),
    ...mapGetters(['locale']),
    renderUpgradeText() {
      return this.translations.displaySecurity
        && !this.isAutoRMAScenario
        && this.deviceVerificationResponse.rmaWarrantyStatus.warrantyState !== 'IN';
    },
    getOutboundProductDetails() {
      return this.deviceVerificationResponse?.rmaOutboundProductDetail;
    },
    getInboundProductDetails() {
      return this.deviceVerificationResponse?.rmaInboundProductDetails;
    },
    isAutoRMAScenario() {
      return this.deviceVerificationResponse?.autoRMAScenario;
    },
    outboundHasInventory() {
      return (
        this.deviceVerificationResponse?.rmaOutboundProductDetail?.outboundInventoryCount || false);
    },
    isCreateOrderButtonDisabled() {
      return (this.isNextDisabled || this.orderConfirmationResponse);
    },
  },
  methods: {
    ...mapActions('order', ['createExchangeOrder']),
    constructUpgradeLink() {
      // eslint-disable-next-line max-len
      return `${window.AppData.supportPublicBaseUrl}/${this.locale}/?contactOverride=true&identifier=${this.deviceVerificationResponse.productId}&tab=topics`;
    },
    async onOrderSubmit() {
      this.hasOrderCreatedError = false;
      this.isNextDisabled = true;

      await this.createExchangeOrder({
        serialNumber: this.suppliedFormData?.serialNumber,
        caseId: this.exchangeIdentifier,
        orderCategory: 'EXCHANGE',
        country: this.getSelectedCountryCode,
        customer: {
          email: this.suppliedFormData?.emailAddress,
        },
      });

      if (this.orderConfirmationResponse) {
        this.analyticsInstance.triggerValidOrderSubmissionAnalytics(
          this.deviceVerificationResponse,
        );
        this.$router.push({ name: 'exchangeConfirmationView', query: this.$route.query });
      } else {
        this.hasOrderCreatedError = true;
        this.analyticsInstance.triggerInvalidOrderSubmissionAnalytics(
          this.translations.orderCreatedFailureMessage,
        );
      }

      this.isNextDisabled = false;
    },
  },
};
